<template>
    <div>
       <HeaderTeam header="รายงานและการสรุปยอด" :img_header="header_image" link_back="summary"/>
       <MenuTeamReportAndSummaryList/>
       <DetailPartTimeSummaryList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/dashboard.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamReportAndSummaryList from '@/components/menuadmin/team/teamreportandsummary/MenuTeamReportAndSummaryList.vue'
import DetailPartTimeSummaryList from '@/components/menuadmin/team/teamreportandsummary/DetailPartTimeSummaryList.vue'
export default {
    name:'detailPartTimeSummary',
    components:{
        HeaderTeam,
        MenuTeamReportAndSummaryList,
        DetailPartTimeSummaryList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>